interface Options {
  title?: string
  description?: string
  confirmText?: string
  cancelText?: string
}

export function useConfirm() {
  const modalStore = useModalStore()

  function confirm(options: Options = {}) {
    return new Promise((resolve) => {
      modalStore.openModal(
        'Confirmation',
        {
          ...options,
          confirmCallback: () => resolve(true),
          cancelCallback: () => resolve(false),
        },
        () => resolve(false),
      )
    })
  }

  return {
    confirm,
  }
}
